import { Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

// used for CC and messages
export const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.custom.lightGrey,
  borderRadius: '1rem',
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  margin: '0.5rem',
  borderRadius: 8,
  minHeight: '4rem',
  [theme.breakpoints.up('md')]: {
    minWidth: '20rem',
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: `${theme.palette.common.white}`,
    transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
}));
